import { window } from '../globals';

/**
 * Frontend helper function for checking if the FOSSA instance in question is on-premise
 */
export const isOnPrem = () => window.on_prem;

/**
 * Frontend helper hook for checking if the FOSSA instance in question is on-premise
 */
export const useIsOnPrem = () => isOnPrem();
